var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "maintain-directory-order-component" },
    [
      _c(
        "div",
        { attrs: { id: "maintain-directory-order-header" } },
        [
          _c("sticky", [
            _c("div", { staticClass: "clearfix header-panel" }, [
              _c("div", { staticClass: "header" }, [
                _c("span", { staticClass: "notice-header" }, [
                  _vm._v(_vm._s(_vm.$t("directory.maintainOrderTitle"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right-btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { disabled: !_vm.allowSave },
                    on: { click: _vm.save },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.save")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { disabled: !_vm.allowPreview },
                    on: { click: _vm.preview },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.preview")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { disabled: !_vm.allowProcess },
                    on: { click: _vm.processClickHandler },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("directory.action.processChangeStatus"))
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "directory-order-search-panel row" }, [
            _c(
              "div",
              {
                staticClass: "multi-select-block multi-select-block--building",
              },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("directory.label.building"))),
                ]),
                _vm._v(" "),
                _c("HKLSelect", {
                  attrs: {
                    value: _vm.searchParams.building,
                    options: _vm.buildingOptions,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: { change: _vm.updateBuildingInQuery },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "multi-select-block multi-select-block--type" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.view")))]),
                _vm._v(" "),
                _c("HKLSelect", {
                  attrs: {
                    value: _vm.searchParams.type,
                    options: _vm.viewTypes,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: { change: _vm.updateTypeInQuery },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.displayFloorSelect,
                    expression: "displayFloorSelect",
                  },
                ],
                staticClass: "multi-select-block multi-select-block--floor",
              },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.floor")))]),
                _vm._v(" "),
                _c("HKLSelect", {
                  attrs: {
                    value: _vm.searchParams.floor,
                    options: _vm.floorList,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: { change: _vm.updateFloorInQuery },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.displayLobbySelect
              ? _c(
                  "div",
                  {
                    staticClass: "multi-select-block multi-select-block--floor",
                  },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("directory.label.floor"))),
                    ]),
                    _vm._v(" "),
                    _c("InputField", {
                      staticClass: "maintain-input-field",
                      attrs: {
                        dirtyCheck: false,
                        value: _vm.searchCompanyParams.floor,
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.updateLobbyFloorInQuery(val)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "multi-select-block multi-select-block--officeName",
              },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("directory.label.officeName"))),
                ]),
                _vm._v(" "),
                _c("InputField", {
                  staticClass: "maintain-input-field",
                  attrs: {
                    dirtyCheck: false,
                    value: _vm.searchCompanyParams.engName,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.updateOfficeNameInQuery(val)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.displayFloorSelect,
                    expression: "displayFloorSelect",
                  },
                ],
                staticClass: "multi-select-block multi-select-block--premises",
              },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("directory.label.premises"))),
                ]),
                _vm._v(" "),
                _c("InputField", {
                  staticClass: "maintain-input-field",
                  attrs: {
                    dirtyCheck: false,
                    value: _vm.searchCompanyParams.premises,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.updatePremisesInQuery(val)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "multi-select-block multi-select-block--date" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("directory.label.date")))]),
                _vm._v(" "),
                _c("DatePicker", {
                  attrs: {
                    calendarButton: true,
                    calendarButtonIcon: "fa fa-calendar",
                    value: _vm.filterParams.date
                      ? new Date(_vm.filterParams.date)
                      : null,
                  },
                  on: {
                    selected: function (val) {
                      return _vm.updateDate(val)
                    },
                    cleared: function ($event) {
                      return _vm.updateDate(null)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "multi-select-block" },
              [
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { disabled: !_vm.canShowDirectory },
                    on: { click: _vm.showDirectory },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.showDirectory")))]
                ),
                _vm._v(" "),
                _c("Popover", {
                  attrs: {
                    text: _vm.$t("directory.hint.onlyShowLevel1"),
                    position: "top-left",
                    width: 300,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("DirectoryOrderTable", {
            ref: "directoryOrderTable",
            on: {
              updateAllowPreview: _vm.updateAllowPreview,
              updateAllowSave: _vm.updateAllowSave,
              updateAllowProcess: _vm.updateAllowProcess,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ActionConfirmModal",
        {
          ref: "processConfirmModal",
          attrs: {
            confirmTitle: _vm.$t("directory.msg.processConfirm.p1", [
              _vm.processItemList.length,
            ]),
          },
          on: {
            "action:afterClose": function () {
              return (_vm.isModalActivated = false)
            },
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c(
              "div",
              { staticClass: "confirm-process-table" },
              [
                _vm.isModalActivated
                  ? _c("CommonTable", {
                      ref: "confirmProcessTable",
                      attrs: {
                        needCache: false,
                        tableContentLists: _vm.processItemList,
                        renderHeaderList: _vm.confirmProcessTableHeader,
                        resizeColumnWhenContentChange: false,
                        defaultOrder: false,
                        needFilter: false,
                        tableId: "confirm-process-table",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-pure-text" }, [
              _vm._v(_vm._s(_vm.$t("directory.msg.processConfirm.p2"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("NoPremisesAtTerminalModal", {
        ref: "noPremisesAtTerminalModal",
        attrs: { companies: _vm.companiesNoPremisesAtTerminal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }